var global = require('../internals/global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/user-agent.js
// module id = 201
// module chunks = 0